var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hidden", attrs: { id: _vm.apartment.id } }, [
    _c("div", { staticClass: "tip-apartment" }, [
      _c("div", { staticClass: "tip-apartment__header" }, [
        _c("div", { staticClass: "tip-apartment__header__residance" }, [
          _vm._v(_vm._s(_vm.apartment.id))
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tip-apartment__header__status",
            class: "tip-apartment__header__status--" + _vm.apartment.status
          },
          [_vm._v("\n        " + _vm._s(_vm.apartment.status) + "\n      ")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tip-apartment__body" }, [
        _c("div", { staticClass: "apartment__detail" }, [
          _c("div", { staticClass: "apartment__detail__label" }, [
            _vm._v("Powierzchnia domu")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "apartment__detail__val" }, [
            _vm._v("\n          " + _vm._s(_vm.apartment.area) + "m"),
            _c("sup", [_vm._v("2")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "apartment__detail" }, [
          _c("div", { staticClass: "apartment__detail__label" }, [
            _vm._v("Liczba pokoi")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "apartment__detail__val" }, [
            _vm._v(_vm._s(_vm.apartment.rooms))
          ])
        ]),
        _vm._v(" "),
        _vm.apartment.garden.length > 1
          ? _c("div", { staticClass: "apartment__detail" }, [
              _c("div", { staticClass: "apartment__detail__label" }, [
                _vm._v("Ogród")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "apartment__detail__val" }, [
                _vm._v("\n          " + _vm._s(_vm.apartment.garden) + "m"),
                _c("sup", [_vm._v("2")])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.apartment.terrace.length > 1
          ? _c("div", { staticClass: "apartment__detail" }, [
              _c("div", { staticClass: "apartment__detail__label" }, [
                _vm._v("Taras")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "apartment__detail__val" }, [
                _vm._v("\n          " + _vm._s(_vm.apartment.terrace) + "m"),
                _c("sup", [_vm._v("2")])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tip-apartment__footer" }, [
        _c("div", { staticClass: "tip-apartment__footer__price" }, [
          _vm.apartment.status == "sold"
            ? _c(
                "span",
                { staticClass: "tip-apartment__header__status--sold" },
                [_vm._v(_vm._s(_vm.apartment.status))]
              )
            : _c("span", [_vm._v(_vm._s(_vm.apartment.price))])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f788a780", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f788a780","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!/Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/partials/ApartmentTooltip.vue
// module id = 44
// module chunks = 0